/**
 * Subtype identifiers for `TemplateType.TOP_PLAYERS_BY_INDICATORS`. Stable
 * snake_case values stored in `media_manager_templates.template_subtypes`.
 */
export const IndicatorSubtype = {
  GOALS: 'goals',
  ASSISTS: 'assists',
  YELLOW_CARD: 'yellow_card',
  RED_CARD: 'red_card',
} as const;

export type IndicatorSubtype = typeof IndicatorSubtype[keyof typeof IndicatorSubtype];
